module.exports = __webpack_public_path__ + "img/xzzg.1f651ced.png";